export default function Audio() {
    const audio = new window.Audio(...arguments)
    audio.preload = "none"
    return audio
}
